import React from 'react';
import { Header } from '@/components/layout/Header';
import { CmsThemedHeader } from '@/components/cms-theme/CmsThemedHeader';
import { CustomHeader } from '@/components/custom-theme/CustomHeader';
import { useContentMode } from '@/hooks/useContentMode';

/**
 * Switches between Hydra Design, Custom Design, and fallback headers
 * based on the current content mode.
 */
export const AdaptiveHeader: React.FC = () => {
  const { isHydraMode, isCustomMode } = useContentMode();
  
  if (isHydraMode) return <CmsThemedHeader />;
  if (isCustomMode) return <CustomHeader />;
  
  return <Header />;
};
